module.exports = __webpack_public_path__ + "media/images/top-parts-04-619814f0880057277f93a1ebc404f8a4.jpg";